import React, { useState, useRef, useEffect } from "react";
import "./AddDocumentVersionModal.css";
import uploadIcon from "../../assets/upload.svg";
import { OrbitProgress } from "react-loading-indicators";
import useOrganizationLimits from "../../hooks/useOrganizationLimits";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import {
  completeDocumentUpload,
  createAgreementVersion,
  createDocumentPresign,
} from "../../store/usersSlice";

const AddDocumentVersionModal = ({
  isOpen,
  onClose,
  agreementId,
  versionToReuploadId,
  onSuccess = () => {},
}) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [thumbnailUrl, setThumbnailUrl] = useState(null);
  const modalRef = useRef(null);
  const fileInputRef = useRef();
  const dispatch = useDispatch();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);
  };

  const handleClearFile = () => {
    setSelectedFile(null);
    setThumbnailUrl(null);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const handleSubmit = async () => {
    if (isLoading || !selectedFile) return;
    setIsLoading(true);
    const formData = {
      language: "ru",
      status: "DRAFT",
      content: "new document version",
      publishedAt: "2026-04-30T02:33:41.754Z",
      effectiveAt: "2026-04-30T02:33:41.754Z",
    };
    let documentVersionId = "";

    if (versionToReuploadId) {
      documentVersionId = versionToReuploadId;
    } else {
      const createVerRes = await dispatch(
        createAgreementVersion({
          agreementId,
          formData,
        })
      );

      if (!createVerRes.error) {
        documentVersionId = createVerRes.payload.id;
      }
    }

    const presignRes = await dispatch(
      createDocumentPresign({
        agreementId,
        documentVersionId,
        contentType: selectedFile.type,
      })
    );

    if (!presignRes.error) {
      const fileKey = presignRes.payload.key;
      const fetchRes = await fetch(presignRes.payload.uploadUrl, {
        method: "PUT",
        headers: presignRes.payload.requiredHeaders,
        body: selectedFile,
      });
      if (!fetchRes.error) {
        const documentData = {
          durationMs: 1000,
        };
        const completeRes = await dispatch(
          completeDocumentUpload({
            agreementId,
            documentVersionId,
            key: fileKey,
          })
        );
        if (!completeRes.error) {
          onSuccess();
        }
      }
    }
  };

  return (
    <div className="modal-overlay">
      <div className="add-version-modal" ref={modalRef}>
        <button className="add-version-close-button" onClick={onClose} />
        <h1 className="add-version-modal-title">
          Добавить новую версию документа
        </h1>
        <div className="add-version-modal-content">
          <label
            className="add-version-upload-area"
            style={{ width: 400, height: 144, marginBottom: 32 }}
          >
            <input
              ref={fileInputRef}
              type="file"
              accept=".pdf, .doc, .docx, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              onChange={handleFileSelect}
              style={{ display: "none" }}
            />
            <img src={uploadIcon} alt="Video thumbnail" style={{ width: 32 }} />
            <div className="add-version-upload-text">
              {selectedFile
                ? selectedFile.name
                : "Выберите документ (pdf, doc, docx)"}
            </div>
          </label>
        </div>
        <button
          className="add-version-submit-button"
          onClick={handleSubmit}
          disabled={!selectedFile}
        >
          {isLoading ? "Загрузка..." : "Загрузить"}
        </button>
      </div>
    </div>
  );
};

export default AddDocumentVersionModal;
